import React from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelInput as Input } from '../../../Elements';
import MaskedInput from 'react-input-mask';

export default class RecipientFields extends React.Component {

  static propTypes = {
    localRecipient: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    submitted: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    this.fieldChange = this.fieldChange.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
  }

  textFieldChange({ target: { name, value } }) {
    this.fieldChange(name, value);
  }

  fieldChange(key, value) {
    const newValue = {};
    newValue[key] = value;
    this.props.onChange(Object.assign({}, this.props.localRecipient, newValue));
  }

  render() {
    const { localRecipient: recipient, submitted } = this.props;
    return (
      <div style={{ textAlign: 'left' }}>
        <Input
          label='First Name'
          name='recipient_first_name'
          placeholder='Jane'
          inline
          validationError='First name is required'
          value={recipient.recipient_first_name || ''}
          onChange={this.textFieldChange}
          submitted={submitted}
          width='50%'
        />
        <Input
          label='Last Name'
          name='recipient_last_name'
          placeholder='Smith'
          inline='last'
          value={recipient.recipient_last_name || ''}
          onChange={this.textFieldChange}
          submitted={submitted}
          width='50%'
        />
        <Input
          label='Company Name'
          name='recipient_company_name'
          placeholder='Acme, Inc.'
          value={recipient.recipient_company_name || ''}
          onChange={this.textFieldChange}
          submitted={submitted}
        />
        <Input
          label='Phone Number'
          type='tel'
          name='recipient_phone'
          placeholder='(555) 555-1212'
          onChange={this.textFieldChange}
          value={recipient.recipient_phone || ''}
          submitted={submitted}
        >
          <MaskedInput
            mask='(999) 999-9999'
            value={recipient.recipient_phone || ''}
          />
        </Input>
        <Input
          label='Email'
          type='email'
          name='recipient_email'
          validations='isEmail'
          validationError='Email address is invalid'
          placeholder='email@example.com'
          value={recipient.recipient_email || ''}
          onChange={this.textFieldChange}
          submitted={submitted}
        />
        <Input
          autoHeight
          rows={2}
          label='Billing Address'
          type='address'
          name='recipient_address'
          placeholder={`123 Elm St.
San Francisco, CA 94105`}
          value={recipient.recipient_address || ''}
          onChange={this.textFieldChange}
          submitted={submitted}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Recipient/RecipientFields.js